module.exports = __webpack_public_path__ + "static/media/20.54bddf26.jpg";